<template>
    <div class="credit-card-information">
        <table width=100%>
            <tr class="credit-card-record">
                <td colspan="2" class="dialog-title" style="text-align: center;padding:15px 0 10px 0;" v-t="'message.title_input_creditCard_info'">
                </td>
            </tr>
            <tr class="credit-card-record">
                <td colspan="2" style="text-align: center">
                    <img class="card-icon" src="../assets/card_visa.jpg"/>
                    <img class="card-icon" src="../assets/card_master.jpg"/>
                    <img v-if="currencyYen" class="card-icon" src="../assets/card_jcb.jpg"/>
                    <img v-if="currencyYen" class="card-icon" src="../assets/card_amex.jpg"/>
                    <img v-if="currencyYen" class="card-icon" src="../assets/card_diners.jpg"/>
                </td>
            </tr>
            <tr class="credit-card-record">
                <td :class="{ 'card-item-title_sm' : smScreen , 'card-item-title' : !smScreen}" v-t="'message.item_card_number'"></td>
            </tr>
            <tr class="credit-card-record">
                <td class="card-item">
                    <el-input :class="{ 'card-number_sm' : smScreen , 'card-number' : !smScreen}" id="cardNumber" ref="cardNumber" type="text" v-model="inputForm.cardNumber.value"
                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheckCardNumber()"/>
                    <div class="errorMessage">{{ errorInfoCardNo }}</div>
                </td>
            </tr>
            <tr class="credit-card-record">
                <td :class="{ 'card-item-title_sm' : smScreen , 'card-item-title' : !smScreen}" v-t="'message.item_card_code'"></td>
            </tr>
            <tr class="credit-card-record">
                <td class="card-item">
                    <el-input class="card-security-code" id="securityCode" ref="securityCode" type="text" v-model="inputForm.securityCode.value"
                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheckSecurityCode()"/>
                    <!-- GMOロゴがリンク切れしているためコメントアウト
                    <div v-if="!smScreen & isJapanese" class="gmo-logo">
                        <a tabindex="-1" href="https://www.gmo-pg.com/" title="クレジットカード決済代行サービス" target="_blank">
                            <img src="https://www.gmo-pg.com/accessibility/link_guideline/img/bnr_200x40.png" alt="東証一部上場企業のカード決済代行を利用しています。GMOペイメントゲートウェイ。"></img>
                        </a>
                    </div>
                    -->
                    <div v-if="showSecurityCodeError" class="errorMessage">{{ errorInfoSecurityCode }}</div>
                </td>
            </tr>
            <tr class="credit-card-record">
                <td :class="{ 'card-item-title_sm' : smScreen , 'card-item-title' : !smScreen}" v-t="'message.item_card_expire'"></td>
            </tr>
            <tr class="credit-card-record">
                <td class="card-item">
                    <el-select class="card-expire" v-model="cardExpireMonth" placeholder="" ref="expireMonth" @change="handleChangeExpireDate">
                        <el-option v-for="month in months"
                            :key="month"
                            :label="month"
                            :value="month">
                        </el-option>
                    </el-select><span :class="{ 'title-font_sm' : smScreen , 'title-font' : !smScreen}" v-t="'message.unit_month'"/>
                    <el-select class="card-expire" v-model="cardExpireYear" style="padding-left:10px" placeholder="" ref="expireYear" @change="handleChangeExpireDate">
                        <el-option v-for="year in years"
                            :key="year"
                            :label="year"
                            :value="year">
                        </el-option>
                    </el-select><span :class="{ 'title-font_sm' : smScreen , 'title-font' : !smScreen}" v-t="'message.unit_year'"/>
                    <div class="errorMessage">{{ errorInfoExpiredDate }}</div>
                </td>
            </tr>
            <tr class="credit-card-record">
                <td :class="{ 'card-item-title_sm' : smScreen , 'card-item-title' : !smScreen}" v-t="'message.item_card_holder'"></td>
            </tr>
            <tr class="credit-card-record">
                <td class="card-item">
                    <el-input :class="{ 'card-holder_sm' : smScreen , 'card-holder' : !smScreen}" type="text" id="cardHolder" ref="cardHolder"  v-model="inputForm.cardHolder.value"
                        @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheckCardHolder()"/>
                    <div v-if="showCardHolderError" class="errorMessage">{{ errorInfoCardHolder }}</div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data () {
        return {
            smScreen: false,
            showSecurityCodeError: true,
            showCardHolderError: true,
            errorInfoCardHolder: "",
            errorInfoCardNo: "",
            errorInfoExpiredDate: "",
            errorInfoSecurityCode: "",
            cardExpireMonth: null,
            cardExpireYear: null,
            card_diners: false,
            card_amex: false,
            months: [ "01" ,  "02" ,  "03" ,  "04" ,  "05" ,  "06" ,  "07" ,  "08" ,  "09" ,  "10" ,  "11" ,  "12" ],
            years: [],
            inputForm: {
                cardNumber:     { validationRule: "numeric",            value: null,   isComposing: false },
                securityCode:   { validationRule: "numeric",            value: null,   isComposing: false },
                cardHolder:     { validationRule: "reqAlphabetName",    value: null,   isComposing: false }
            },
        };
    },
    methods: {
        cardInfoValidation() {
            let validation = true;
            if (this.inputForm.cardNumber.value != null) {
                if ((this.card_diners) & (this.inputForm.cardNumber.value.length < 14)) {
                    this.errorInfoCardNo = commonUtil.getMessageText(this.$i18n,"error_input_14digit_cardNumber");
                    validation = false;
                }
                if ((this.card_amex) & (this.inputForm.cardNumber.value.length < 15)) {
                    this.errorInfoCardNo = commonUtil.getMessageText(this.$i18n,"error_input_15digit_cardNumber");
                    validation = false;
                }
                if ((!this.card_diners) & (!this.card_amex) & (this.inputForm.cardNumber.value.length < 16)) {
                    this.errorInfoCardNo = commonUtil.getMessageText(this.$i18n,"error_input_16digit_cardNumber");
                    validation = false;
                }
            } else {
                this.errorInfoCardNo = commonUtil.getMessageText(this.$i18n,"error_validate_not_found");
                validation = false;
            }

            if (this.inputForm.securityCode.value != null) {
                if (this.inputForm.securityCode.value.length < 3) {
                    this.errorInfoSecurityCode = commonUtil.getMessageText(this.$i18n,"error_input_security_code");
                    validation = false;
                } else {
                    this.errorInfoSecurityCode = "";
                }
            } else {
                this.errorInfoSecurityCode = commonUtil.getMessageText(this.$i18n,"error_input_security_code");
                validation = false;
            }

            if ((this.cardExpireYear == null) || (this.cardExpireMonth == null)) {
                this.errorInfoExpiredDate = commonUtil.getMessageText(this.$i18n,"error_input_expire_date");
                validation = false;
            } else {
                if (!this.checkExpireDate()) {
                    validation = false;
                }
            }

            if ((this.inputForm.cardHolder.value == null) || (this.inputForm.cardHolder.value == "")) {
                this.errorInfoCardHolder = commonUtil.getMessageText(this.$i18n,"error_input_card_holder");
                validation = false;
            } else {
                if (this.errorInfoCardHolder != "") {
                    validation = false;
                }
            }
            this.$emit('on-change-input', this.inputForm.cardNumber.value , this.inputForm.securityCode.value , this.cardExpireYear + this.cardExpireMonth , this.inputForm.cardHolder.value , validation);
        },
        handleChangeExpireDate(event) {
            this.errorInfoExpiredDate = "";

            if ((this.cardExpireMonth != null) && (this.cardExpireYear != null)) {
                if (this.checkExpireDate()) {
                    this.cardInfoValidation();
                } else {
                    this.$emit('on-change-input', this.inputForm.cardNumber.value , this.inputForm.securityCode.value , this.cardExpireYear + this.cardExpireMonth , this.inputForm.cardHolder.value , false);
                }
            } else {
                this.errorInfoExpiredDate = commonUtil.getMessageText(this.$i18n,"error_input_expire_date");
                this.$emit('on-change-input', this.inputForm.cardNumber.value , this.inputForm.securityCode.value , this.cardExpireYear + this.cardExpireMonth , this.inputForm.cardHolder.value , false);
            }
        },
        inputCheckCardNumber() {
            if (this.inputForm.cardNumber.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm.cardNumber.validationRule, this.inputForm.cardNumber.value);
            if (validateResult.valid) {
                this.errorInfoCardNo = "";
                if (this.inputForm.cardNumber.value.length < 16) {
                    if ((this.inputForm.cardNumber.value.indexOf("30") == 0) ||
                        (this.inputForm.cardNumber.value.indexOf("36") == 0) ||
                        (this.inputForm.cardNumber.value.indexOf("38") == 0) ||
                        (this.inputForm.cardNumber.value.indexOf("39") == 0)) {
                        this.card_diners = true;
                        // Diners
                        if (this.inputForm.cardNumber.value.length == 14) {
                            this.$refs.securityCode.focus();
                            return;
                        } else {
                            this.cardInfoValidation();
                            return;
                        }
                    }
                    if ((this.inputForm.cardNumber.value.indexOf("37") == 0) ||
                        (this.inputForm.cardNumber.value.indexOf("34") == 0)) {
                        this.card_amex = true;
                        // American express
                        if (this.inputForm.cardNumber.value.length == 15) {
                            this.$refs.securityCode.focus();
                            return;
                        } else {
                            this.cardInfoValidation();
                            return;
                        }
                    }
                    this.cardInfoValidation();
                    return;
                }
                if (this.inputForm.cardNumber.value.length == 16) {
                    this.$refs.securityCode.focus();
                    return;
                }
                this.cardInfoValidation();
            } else {
                this.errorInfoCardNo = validateResult.message;
            }
        },
        inputCheckSecurityCode() {
            if (this.inputForm.securityCode.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm.securityCode.validationRule, this.inputForm.securityCode.value);
            if (validateResult.valid) {
                this.errorInfoSecurityCode = "";
            } else {
                this.errorInfoSecurityCode = validateResult.message;
            }
            if (this.card_amex) {
                if (this.inputForm.securityCode.value.length == 4) {
                    this.$refs.expireMonth.focus();
                }
            } else {
                if (this.inputForm.securityCode.value.length == 3) {
                    this.$refs.expireMonth.focus();
                }
            }
            this.cardInfoValidation();
        },
        inputCheckCardHolder() {
            if (this.inputForm.cardHolder.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm.cardHolder.validationRule, this.inputForm.cardHolder.value);
            if (validateResult.valid) {
                this.errorInfoCardHolder = "";
            } else {
                this.errorInfoCardHolder = validateResult.message;
            }
            this.cardInfoValidation();
        },
        checkExpireDate() {
            let yearNow = Number(new Date().getFullYear().toString().substr(2,2));
            let monthNow = Number(new Date().getMonth()) + 1;
            if ((Number(this.cardExpireYear) > yearNow) && (this.cardExpireMonth != null)) {
                return true;
            }
            if (Number(this.cardExpireMonth) < monthNow) {
                this.errorInfoExpiredDate = commonUtil.getMessageText(this.$i18n,"error_invalid_expire_date");
                return false;
            }
            return true;
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            switch(eventTargetId) {
                case "cardNumber":
                    this.inputCheckCardNumber();
                    break;
                case "securityCode":
                    this.inputCheckSecurityCode();
                    break;
                default:
                    this.inputCheckCardHolder();
                    break;

            }
        },
        saveCreditCardInfo(info, purchasePlanType) {
            let self = this;

            const loadingScreen = self.$loading({
                    lock: true ,
                    text: 'Confirming credit card ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0.7)'
            });

            Multipayment.init(this.gmoShopId);
            Multipayment.getToken({
                cardno : this.inputForm.cardNumber.value,
                expire : this.cardExpireYear + this.cardExpireMonth,
                holdername : this.inputForm.cardHolder.value,
            }, function(response) {
                if (response.resultCode != "000") {
                    loadingScreen.close();
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_register_card").replace("{errorInfo}", response.resultCode));
                    return;
                }
  
                const req = {
                    token: response.tokenObject.token,
                    securityCode: self.inputForm.securityCode.value,
                    currency: self.currencyYen ? 2 : 1,
                    licensePlanType: purchasePlanType,
                    purchasePeriodType: info === null ? 0 : info.purchasePeriodType,
                    licenseCount: info === null ? 0 : info.license.numberLicense[0].newValue
                }

                server.post('/entrygmo3dsecure', req)
                .then((res) => {
                    loadingScreen.close();
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.$emit('redirect', res.data.redirectUrl)
                    } else {
                        switch (res.data.status) {
                            case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                                if (res.data.errorCtx) {
                                    commonUtil.notifyMessage(self,"Error", res.data.errorCtx);
                                    return
                                }

                                if ((res.data.errorInfo.indexOf("42G")== 0) ||
                                    (res.data.errorInfo.indexOf("E41")== 0) ||
                                    (res.data.errorInfo.indexOf("E61")== 0)) {
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_creditCard_validation").replace("{errorInfo}", res.data.errorInfo));
                                } else {
                                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_other_system").replace("{functionName}","saveCreditCardInfo").replace("{code}",res.data.errorInfo));
                                }
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveCreditCardInfo").replace("{code}",res.data.status));
                                break;
                        }
                        return;
                    }
                })
                .catch( function ( error ) {
                    loadingScreen.close();
                    commonUtil.putExceptionErrorMessage(self, "saveCreditCardInfo", error);
                });
            });
        },
        getCreditCardToken() {
            let self = this;

//            const loadingScreen = self.$loading({
//                    lock: true ,
//                    text: 'Confirming credit card ...' ,
//                    spinner: 'el-icon-loading' ,
//                    background: 'rgba(0, 0, 0, 0.7)'
//            });
            Multipayment.init(this.gmoShopId);
            Multipayment.getToken({
                cardno : this.inputForm.cardNumber.value,
                expire : this.cardExpireYear + this.cardExpireMonth,
                holdername : this.inputForm.cardHolder.value,
            }, function(response) {
                if (response.resultCode != "000") {
  //                  loadingScreen.close();
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_register_card").replace("{errorInfo}", response.resultCode));
                    return;
                }
                self.$emit('getToken', response.tokenObject.token);
           });
        },
    },
    created: function() {
        if (commonUtil.isSmartPhoneScreen()) {
            this.smScreen = true;
        }
        let yearNow = Number(new Date().getFullYear().toString().substr(2,2));
        for (let i = 0 ; i < 10 ; i++) {
            this.years.push(('00' + (i + yearNow)).slice(-2));
        }
    },
    mounted: function() {
        if (this.definedCardNumber != null) {
            this.inputForm.cardNumber.value = this.definedCardNumber;
        }
        if (this.definedExpiredDate != null) {
            this.cardExpireYear = this.definedExpiredDate.substr(0,2);
            this.cardExpireMonth = this.definedExpiredDate.substr(2,2);
        }
        if (this.definedHolderName != null) {
            this.inputForm.cardHolder.value = this.definedHolderName;
        }

//        this.inputForm.cardNumber.value = "4111111111111111"
//        this.inputForm.securityCode.value = "111"
//        this.inputForm.cardHolder.value = "OKIMOTO"
//        this.cardExpireYear = "21"
//        this.cardExpireMonth = "01"

        // load GMOPayment's script.
        let externalScript = document.createElement('script');
        externalScript.setAttribute('src', this.gmoSeverScriptPath);
        document.head.appendChild(externalScript);

    },
    watch: {
        'errorInfoSecurityCode'(newVal) {
            // error message was not cleared without redraw on Edge,
            if (newVal == "") {
                this.showSecurityCodeError = false;
                this.$nextTick(() => {
                    this.showSecurityCodeError = true;
                });
            }
        },
        'errorInfoCardHolder'(newVal) {
            // error message was not cleared without redraw on Edge,
            if (newVal == "") {
                this.showCardHolderError = false;
                this.$nextTick(() => {
                    this.showCardHolderError = true;
                });
            }
        }
    },
    computed: {
        isJapanese() {
            return (this.$i18n.locale == 'ja')
        }
    },
    props: [ 'definedCardNumber' , 'definedExpiredDate' , 'definedHolderName' , 'currencyYen' , 'gmoSeverScriptPath' , 'gmoShopId' , 'signUpMode' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gmo-logo {
    display: inline-block;
    vertical-align: middle;
    height: 40px;
}
.gmo-logo-small {
    padding-left:72px;
    display: inline-block;
    vertical-align: middle;
}
.card-item-title {
    padding-left:10px;
    width:150px;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
}
.card-item-title_sm {
    font-size: 12px;
    padding-left:10px;
    width:150px;
    text-align: left;
    font-weight: bold;
    font-size: 14px;
}

.credit-card-box {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #f6f6f6;
}
.credit-card-information {
    padding: 10px;
}
.credit-card-record {
    padding-top: 10px;
}

.card-item {
    padding-left: 15px;
    padding-top: 10px;
    text-align: left;
/*    padding-bottom: 10px; */
}
.card-item-error {
    padding-left: 15px;
    padding-top: 10px;
}
.card-item >>> .el-input__inner {
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
}

.card-security-code {
    width: 65px;
    padding-right: 10px;
}
.card-security-code >>> .el-input__inner {
    padding-left: 15px;
    text-align: left;
}

.card-number {
    width: 280px;
}
.card-number_sm {
    width: 205px;
}
.card-number >>> .el-input__inner,
.card-number_sm >>> .el-input__inner {
    padding-left: 15px;
    text-align: left;
}

.card-icon {
    height: 30px;
    padding: 10px;
}
.card-expire {
    width: 65px;
    padding-right: 10px;
}
.card-expire >>> .el-input__inner {
    padding-left: 15px;
    text-align: left;
}

.card-holder {
    width: 280px;
}
.card-holder_sm {
    width: 205px;
}
.card-holder >>> .el-input__inner,
.card-holder_sm >>> .el-input__inner {
    padding-left: 15px;
    padding-right: 0px;
    text-align: left;
}

.title-font {
    font-size: 14px;
}
.title-font_sm {
    font-size:12px;
}

.errorMessage {
    color: #d55169;
    font-size: 11px;
    height: 11px;
    padding-top: 4px;
}
</style>
